// extracted by mini-css-extract-plugin
module.exports = {"mobileHorizontalScrollContainer":"technologies-section-module--mobile-horizontal-scroll-container--3rcdm","gridContainer":"technologies-section-module--grid-container--39jHE"};